const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export default {
    SERVER_HOST: IS_DEV ? 'http://localhost:9090' : "https://api.pickndropservices.com",
    WS_HOST: IS_DEV ? 'wss://localhost:9090' : "wss://api.pickndropservices.com",
    API_URL: '/api/v1/',
    FILE_URL: '/files/',
    WS: 'ws',
    LOGIN: 'admin/login',
    UPDATE_PROFILE: 'admin/update/profile',
    UPDATE_PASSWORD: 'admin/update/password',

    AREA_ADD: 'area/new',
    AREA_LIST: 'area/list',
    AREA_DETAIL: 'area/find',
    AREA_UPDATE_STATUS: 'area/update/status',
    AREA_UPDATE_DETAILS: 'area/update/details',

    COUNTRY_ADD: 'country/new',
    COUNTRY_LIST: 'country/list',
    COUNTRY_DETAIL: 'country/find',
    COUNTRY_UPDATE_DETAILS: 'country/update/details',

    REQUEST_TYPE_ADD: 'request_type/new',
    REQUEST_TYPE_LIST: 'request_type/list',
    REQUEST_TYPE_DELETE: 'request_type/delete',
    REQUEST_TYPE_UPDATE_DETAILS: 'request_type/update/details',
    REQUEST_TYPE_UPDATE_STATUS: 'request_type/update/status',
    REQUEST_TYPE_FIND: 'request_type/find',

    MEANS_TYPE_ADD: 'means_type/new',
    MEANS_TYPE_LIST: 'means_type/list',
    MEANS_TYPE_DELETE: 'means_type/delete',
    MEANS_TYPE_UPDATE_DETAILS: 'means_type/update/details',
    MEANS_TYPE_UPDATE_STATUS: 'means_type/update/status',
    MEANS_TYPE_FIND: 'means_type/find',

    PEAK_HOURS_ADD: 'peak_hour/new',
    PEAK_HOURS_LIST: 'peak_hour/list',
    PEAK_HOURS_DELETE: 'peak_hour/delete',

    RATE_ADD: 'rate/new',
    RATE_LIST: 'rate/list',
    RATE_DELETE: 'rate/delete',
    RATE_UPDATE: 'rate/update',

    REGION_ADD: 'region/new',
    REGION_LIST: 'region/list',
    REGION_DETAIL: 'region/find',
    REGION_UPDATE_STATUS: 'region/update/status',
    REGION_UPDATE_DETAILS: 'region/update/details',

    RIDER_ADD: 'rider/new',
    RIDER_LIST: 'rider/list',
    RIDER_DETAIL: 'rider/find',
    RIDER_UPDATE_STATUS: 'rider/update/status',
    RIDER_UPDATE_DETAILS: 'rider/update/details',

    REQUEST_LIST: 'request/list-admin',
    REQUEST_LIST_RIDER: 'request/list-rider',
    REQUEST_LIST_USER: 'request/list-user-admin',
    REQUEST_STATS: 'request/list-admin-stats',
    REQUEST_TIMER: 'request/list-admin-timer',
    REQUEST_DETAIL: 'request/find-admin',
    REQUEST_UPDATE_DELIVERY: 'request/update-delivery',
    REQUEST_ASSIGN_RIDER: 'request/assign-rider',
    REQUEST_ASSIGN_REGION: 'request/assign-region',
    REQUEST_CANCEL: 'request/cancel-admin',
    REQUEST_RECEIVE: 'request/cc/receive',

    REQUEST_LOG_LIST: 'request-log/list',
    REQUEST_LOG_DETAIL: 'request-log/find',

    CLIENT_LIST: 'user/list',
    CLIENT_DETAIL: 'user/find',
    CLIENT_UPDATE_STATUS: 'user/update/status',

    BUSINESS_LIST: 'business/list-admin',
    BUSINESS_DETAIL: 'business/find-admin',
    BUSINESS_UPDATE_STATUS: 'business/update/status-admin',
    BUSINESS_APPROVE: 'business/approve-admin',
    BUSINESS_REJECT: 'business/reject-admin',
    BUSINESS_WALLET_TOPUP: (id) => `business/${id}/wallet/topup`,
    BUSINESS_WALLET_DEBIT: (id) => `business/${id}/wallet/debit`,

    INVOICE_LIST_ADMIN: 'invoice/list-admin',
    INVOICE_FIND_ADMIN: 'invoice/find-admin',
    INVOICE_UPDATE_STATUS_ADMIN: 'invoice/update/status-admin',
    INVOICE_UPDATE_PAYMENT_ADMIN: 'invoice/update/payment-admin',
    INVOICE_GENERATE_ADMIN: 'invoice/generate-admin',

    DEPARTMENT_LIST: 'department/list-admin',
    DEPARTMENT_DETAIL: 'department/find-admin',
    DEPARTMENT_UPDATE_STATUS: 'department/update/status-admin',

    CHILD_ACCOUNT_LIST: 'child-account/list-admin',
    CHILD_ACCOUNT_DETAIL: 'child-account/find-admin',
    CHILD_ACCOUNT_UPDATE_STATUS: 'child-account/update/status-admin',
    CHILD_ACCOUNT_DELETE_ADMIN: 'child-account/delete-admin',
    CHILD_ACCOUNT_TRANSFER_ADMIN: 'child-account/transfer-admin',
    CHILD_ACCOUNT_RESEND_INVITE_ADMIN: 'child-account/resend-invitation-admin',

    BUSINESS_DOCUMENTS_ADMIN: 'business/document/list-admin',

    ADMIN_DASHBOARD: 'admin/dashboard',

    SEND_BROADCAST: 'broadcast/new',
    LIST_BROADCAST: 'broadcast/list',
    LIST_SCHEDULED_BROADCAST: 'broadcast/scheduled',
    DELETE_BROADCAST: 'broadcast/delete',

    LIST_SETTINGS: 'settings/list',
    UPDATE_SETTINGS: 'settings/update',

    NEW_PROMO: 'promo/new',
    LIST_PROMO: 'promo/list',
    DELETE_PROMO: 'promo/delete',

    LIST_ROLES: 'roles',
    LIST_ADMINS: 'admins',
    ASSIGN_ROLE: (id) => `admin/${id}/assign-role`,
    LIST_AUDIT: 'audit/list',
    GET_AUDIT: (id) => `audit/${id}`,
    MFA_ENROL: 'admin/mfa/enrol',
    MFA_VERIFY: 'admin/mfa/verify',
    MFA_DISABLE: 'admin/mfa/disable',
    LOGIN_MFA: 'admin/login/mfa',
    LOGOUT: 'admin/logout',
    REVOKE_SESSION: (id) => `admin/sessions/${id}/revoke`,

    LIST_PENDING_RIDERS: 'riders/pending',
    RIDER_VETTING_DETAIL: 'rider/vetting-detail',
    APPROVE_RIDER_VETTING: 'rider/approve',
    REJECT_RIDER_VETTING: 'rider/reject',
    UPLOAD_RIDER_DOC: 'rider/doc/upload',
    LIST_TRANSFER_HUBS: 'transfer_hubs',
    CREATE_TRANSFER_HUB: 'transfer_hubs',
    UPDATE_TRANSFER_HUB: (id) => `transfer_hubs/${id}`,
    DELETE_TRANSFER_HUB: (id) => `transfer_hubs/${id}/delete`,
    CHAIN_OF_CUSTODY: (id) => `request/${id}/chain-of-custody`,
    MANUAL_HANDOVER: 'admin/handover/force',

    LIST_COMPLAINTS: 'complaints',
    GET_COMPLAINT: (id) => `complaints/${id}`,
    TRIAGE_COMPLAINT: (id) => `complaint/${id}/triage`,
    RESOLVE_COMPLAINT: (id) => `complaint/${id}/resolve`,
    REFUND_COMPLAINT: (id) => `complaint/${id}/refund`,

    POST_RIDER_PENALTY: (id) => `rider/${id}/penalty`,
    POST_RIDER_REWARD: (id) => `rider/${id}/reward`,
    RIDER_LEDGER: (id) => `rider/${id}/ledger`,
    TOP_RIDERS: 'riders/top',
    WALLET_TOPUP: (id) => `business/${id}/wallet/topup`,
    WALLET_DEBIT: (id) => `business/${id}/wallet/debit`,
    BUSINESS_LEDGER: (id) => `business/${id}/wallet/ledger`,
    STATEMENT: 'statement',
    TRANSACTION_LIST_ADMIN: 'transactions',
    SYSTEM_RESET: 'system/reset',

    ANALYTICS_OVERALL: 'analytics/overall',
    ANALYTICS_REVENUE_BY_TIER: 'analytics/revenue-by-tier',
    ANALYTICS_COMPLAINTS_BY_CATEGORY: 'analytics/complaints-by-category',
    ANALYTICS_RIDER_PERFORMANCE: 'analytics/rider-performance',
    LIST_FLAGGED_USERS: 'users/flagged',
    TOGGLE_PREPAY_ONLY: (id) => `user/${id}/prepay-only`,

    LIST_PENDING_LOANS: 'loans/pending',
    APPROVE_LOAN: (id) => `loan/${id}/approve`,
    REJECT_LOAN: (id) => `loan/${id}/reject`,
    DISBURSE_LOAN: (id) => `loan/${id}/disburse`,

    // Developer API — admin visibility (keys, webhook health, audited revoke).
    API_KEYS_LIST_ADMIN: 'api-keys/list-admin',
    API_KEY_REVOKE_ADMIN: 'api-keys/revoke-admin',
    API_WEBHOOKS_ADMIN: 'api-keys/webhooks-admin',

};
